import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css"
import DatePicker from "react-datepicker";
import ReactToPdf from "react-to-pdf";
import logo from "./images/loading.gif";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import 'react-month-picker-dropdown/dist/index.css';
import '../scss/green-theme.css';
import ModalLogin from './ModalLogin';
//import Mymodal from './modal';
//import config from '../config';
import Cookies from "universal-cookie";
import logonorecord from "./images/recordnotfound.png";
const axios = require("axios");
const ref = React.createRef();
const cookies = new Cookies();
export default class Fuel extends Component{
  constructor(props)
  {
    super(props);
    this.state=
    { input:{},
      myitems:[],
      isLoaded: false,
      islocation:false,
      isData: false,
      fromDate: new Date(),
      toDate: new Date(),
      ErrMsg:"",
      FuellDiff:0,
      MileageDiff:0,
      TotalMileage:0,
      divonoff:"none",
      
      fdate: Moment(new Date()).format("DD/MM/YYYY"),
      tdate: Moment(new Date()).format("DD/MM/YYYY")

    };
    this.handlechangefrom = this.handlechangefrom.bind(this);
    this.handlechangeto = this.handlechangeto.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  //  this.rendercontent = this.rendercontent.bind(this);

  }
  cur(num) 
  {
    
    let cnum=parseFloat(num,2);
    if(cnum > 0)
        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
  }
  cur2(num) 
  {
//    let cnum=parseInt(num,2);
    if(num > 0)
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
  }
  componentDidMount()
  {
    let input = this.state.input;
    if(cookies.get("LoginID"))
    { input["ID"]=cookies.get("LoginID");
      this.setState({ErrMsg:"",islocation:true,isLoaded:true,myitems:[]});
    }
    else
    { this.setState({ErrMsg:<ModalLogin/>});}
  }
  handlechangefrom(date)
  {
    this.setState({fdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({fromDate: date});
  }
  handlechangeto(date)
  {
    this.setState({tdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({toDate:date});
  }
  handleSubmit()
    {
      document.body.style.cursor="wait";
      this.setState({ErrMsg:<img src={logo} alt=""/>,divonoff:"none"});
      let input=this.state.input;
      
      input["DateFrom"]=this.state.fdate;
      input["DateTo"]=this.state.tdate;
      this.setState({input});
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/userv/fuel/',
          data: this.state.input,
          headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
        document.body.style.cursor="default";
        if(response.data==0)
          this.setState({ErrMsg:<img style={{paddingTop:50}} src={logonorecord} alt=""/>,divonoff:"none"});
        else
        
          this.setState({
              isLoaded: true,
              islocation:true,
              ErrMsg:"",
              divonoff:"block",
              myitems: response.data
          });
      })
      .catch((response)=> {
        document.body.style.cursor="default";
        this.setState({ErrMsg:<img src={logonorecord} alt=""/>,divonoff:"none"});
      })
    }
  
    render()
    {
      let fileName=this.state.input["ID"]+"-fuel.pdf";
      let items = this.state.myitems;
      let TotalMileage=0;
      let TotalFuel=0;
      let mileage1=0;
      let totalitems=this.state.myitems.length;
      return(

        <div className="container1">
          <br></br>
          <div width="100%"  >
          <div className='inner-profile'>
          <span className="box-title">Fuel Expenses</span>
          <div className="inner-profile2" >
          <label style={{paddingLeft:2,width:"85px"}}>From: </label>
              <DatePicker                          
                selected={this.state.fromDate}
                value = {this.state.fromDate}
                onChange={this.handlechangefrom}
                name="fromDate"
                dateFormat="dd/MM/yyyy" className="form_control"/>
          <br></br>
          <label style={{paddingLeft:2,width:"85px"}} >To:</label>
              <DatePicker
                selected={ this.state.toDate }
                value = {this.state.toDate}
                onChange={this.handlechangeto}
                name="toDate"
                dateFormat="dd/MM/yyyy" className="form_control"/>
            <button onClick={this.handleSubmit} >Submit</button>
        </div>
        <br></br><br></br>
          
          <div style={{width:"100%",textAlign:"center",display:this.state.divonoff}} >
            <div ref={ref}>
              <table style={{width:"100%"}} >
                  <thead>
                  <tr className="tr">
                    <th className="thm" scope="col">Date (dd/mm/yyyy)</th>
                    <th className="thm" scope="col">Vehicle#</th>
                    <th className="thm" scope="col">Payment Mode</th>
                    <th className="thm" scope="col">Fuel Type</th>
                    <th className="thm" scope="col">Previous Reading (KM)</th>
                    <th className="thm" scope="col">Current Reading (KM)</th>
                    <th className="thm" scope="col">Quantity Ltr/Kg</th>
                    <th className="thm" scope="col">Amount</th>
                  </tr>
                  </thead>
                  <tbody>

                            {items.map((result ,i) => {
                                TotalFuel = TotalFuel + Number(result.Fuel_Qty)
                                if(i === 0)
                                {
                                    mileage1= result.Veh_Curr_Mreading;
                                  }
                                if(i === totalitems - 1)
                                {
                                    TotalMileage= result.Veh_Curr_Mreading-mileage1;
                                    TotalFuel = TotalFuel - Number(result.Fuel_Qty);

                                }
                             
                                return (
                                  <tr className="trc" key={i}>
                                    <td className="td" >{Moment(result.expens_Date).format("DD/MM/YYYY")}</td>
                                    <td className="td" >{result.Veh_Reg_Num}</td>
                                    <td className="td" >{result.Payment_Mode}</td>
                                    <td className="td" >{result.Fuel_Type}</td>
                                    <td className="td" >{result.Veh_Prev_Mreading}</td>
                                    <td className="td" >{result.Veh_Curr_Mreading}</td>
                                    <td className="td" >{this.cur(result.Fuel_Qty)}</td>
                                    <td className="td" >{this.cur(result.Fuel_Amt)}</td>                                    
                                  </tr>
                            )})}
                          </tbody>
                        </table>
                        <h6>
                        <div >Fuel average = {this.cur2(TotalMileage/TotalFuel)} KM/Ltr.</div>
{/*}                        <div >Total mileage / Total fuel = {TotalMileage}+" / " +{TotalFuel}</div>*/}

                        </h6>
                      </div>
                        <div align="center" width="650px">
                <ReactToPdf targetRef={ref} filename={fileName} x={8} y={15}>
                  {({toPdf}) => (
                    <button onClick={toPdf} style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                  )}
                </ReactToPdf>
            </div>

                  </div>
            <br></br>

          </div>

         </div>
         <div style={{textAlign:"center",width:"100%"}}>{this.state.ErrMsg}</div>

          </div>
        );
  }
}

